import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { workstatusOptions } from '../../../constants/utils';
import { useTranslation } from 'react-i18next';

/**
 * Shared component for work order status display
 *
 * @param {string} status - Status value (SUBMITTED, IN_PROGRESS, RESOLVED, etc.)
 * @param {boolean} showIcon - Show icon (default: true)
 * @param {boolean} showBorder - Show border (default: true)
 * @param {boolean} uppercase - Uppercase label (default: true)
 * @param {string} className - Additional CSS classes
 */
const WorkOrderStatusBadge = ({
  status,
  showIcon = true,
  showBorder = true,
  uppercase = true,
  className = '',
}) => {
  const { t } = useTranslation();
  const option = workstatusOptions(t).find((opt) => opt.value === status) || {
    label: status || t('shared.unknown', 'Unknown'),
    icon: 'help-circle',
    colorClass: 'bg-secondary text-white',
    borderColor: '#6c757d',
  };

  const label = uppercase ? option.label.toUpperCase() : option.label;

  return (
    <span
      className={`badge rounded-pill py-1 px-2 d-inline-flex align-items-center gap-1 ${option.colorClass} ${className}`}
      style={showBorder ? { border: `1px solid ${option.borderColor}` } : undefined}
    >
      {showIcon && <FeatherIcon icon={option.icon} size={12} />}
      {label}
    </span>
  );
};

export default WorkOrderStatusBadge;
